import type { LearningGrain } from '@/core/domain/learning/grain/LearningGrain.ts'
import type { ILearningGrainRepository } from '@/core/domain/learning/grain/ILearningGrainRepository.ts'
import type { ILearningGrainURLOptions } from '@/core/domain/learning/grain/ILearningGrainURLOptions.ts'

export class FetchLearningGrainUseCase {
  private learningGrainRepository: ILearningGrainRepository

  constructor(learningGrainRepository: ILearningGrainRepository) {
    this.learningGrainRepository = learningGrainRepository
  }

  async execute(
    courseId: number,
    moduleId: number,
    grainId: number,
    options?: ILearningGrainURLOptions
  ): Promise<LearningGrain> {
    return this.learningGrainRepository.fetchLearningGrain(courseId, moduleId, grainId, options)
  }
}
